// extracted by mini-css-extract-plugin
module.exports = {"empty":"cuadrilleros_empty__2_Ljs","list":"cuadrilleros_list__146mb","special":"cuadrilleros_special__1y3CX","li":"cuadrilleros_li__1JyBK","form":"cuadrilleros_form__2INfy"};